import { render, staticRenderFns } from "./Definitions.vue?vue&type=template&id=d15cc436&scoped=true&"
import script from "./Definitions.vue?vue&type=script&lang=js&"
export * from "./Definitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15cc436",
  null
  
)

export default component.exports